const TABS = [
  { id: 'feed',         label: 'My feed' },
  { id: 'history',      label: 'History' },  // UX54
  { id: 'analytics',    label: 'Analytics' },
  { id: 'propose',      label: 'Propose' },
  { id: 'jurisdiction', label: 'Jurisdiction' },
]

export function TabBar({ active, onChange }) {
  return (
    <nav className="tabbar" aria-label="Primary">
      <div className="tabbar-inner">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`tab ${active === t.id ? 'active' : ''}`}
            onClick={() => onChange(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
    </nav>
  )
}
